import { render, staticRenderFns } from "./member.vue?vue&type=template&id=2e984c7a&"
import script from "./member.vue?vue&type=script&lang=ts&"
export * from "./member.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports